/**
 * @generated SignedSource<<b75b9cc5ec9efbf205ced8d15d7108da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dataHubStep_FinalizeMutation$variables = {
  token?: string | null | undefined;
};
export type dataHubStep_FinalizeMutation$data = {
  readonly leadFinalize: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly position: number | null | undefined;
      readonly status: string;
      readonly waitDays: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type dataHubStep_FinalizeMutation = {
  response: dataHubStep_FinalizeMutation$data;
  variables: dataHubStep_FinalizeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHubStep_FinalizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeadFinalizeMutationPayload",
        "kind": "LinkedField",
        "name": "leadFinalize",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dataHubStep_FinalizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeadFinalizeMutationPayload",
        "kind": "LinkedField",
        "name": "leadFinalize",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9fbe80ff6c5f310c0e896bd1fb7adc97",
    "id": null,
    "metadata": {},
    "name": "dataHubStep_FinalizeMutation",
    "operationKind": "mutation",
    "text": "mutation dataHubStep_FinalizeMutation(\n  $token: String\n) {\n  leadFinalize(token: $token) {\n    lead {\n      status\n      position\n      waitDays\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a09112da714df9af037303c9d8acbf3";

export default node;
